import { MultiplayerMap } from "../games"

export const idMaps: MultiplayerMap[] =[
    {
        name: 'dm1',
        title: 'Place of Two Deaths',
        author: 'id Software',
        played: 'rarely',
        size: 'medium',
        mod: 'dm'
    },
    {
        name: 'dm2',
        title: 'Claustrophobopolis',
        author: 'id Software',
        played: 'regularly',
        size: 'large',
        mod: 'dm'
    },
    {
        name: 'dm3',
        title: 'The Abandoned Base',
        author: 'id Software',
        played: 'regularly',
        size: 'large',
        mod: 'dm'
    },
    {
        name: 'dm4',
        title: 'The Bad Place',
        author: 'id Software',
        played: 'regularly',
        size: 'small',
        mod: 'dm'
    },
    {
        name: 'dm5',
        title: 'The Cistern',
        author: 'id Software',
        played: 'rarely',
        size: 'medium',
        mod: 'dm'
    },
    {
        name: 'dm6',
        title: 'The Dark Zone',
        author: 'id Software',
        played: 'occasionally',
        size: 'small',
        mod: 'dm'
    }
]

export const customDmMaps: MultiplayerMap[] = [
    {
        name: 'aerowalk',
        title: 'Aerowalk',
        author: 'Preacher',
        played: 'regularly',
        size: 'medium',
        mod: 'dm'
    },
    {
        name: 'ztndm3',
        title: 'Blood Run',
        author: 'Ztn',
        played: 'regularly',
        size: 'small',
        mod: 'dm'
    },
    {
        name: 'bravado',
        title: 'Bravado',
        author: 'foogs',
        played: 'regularly',
        size: 'medium',
        mod: 'dm'
    },
    {
        name: 'skull',
        title: 'Skull',
        author: 'Zaka',
        played: 'occasionally',
        size: 'small',
        mod: 'dm'
    },
    {
        name: 'nova',
        title: 'Nova',
        author: 'alice',
        played: 'occasionally',
        size: 'medium',
        mod: 'dm'
    },
    {
        name: 'schloss',
        title: 'Schloss',
        author: 'Zaka',
        played: 'regularly',
        size: 'large',
        mod: 'dm'
    },
    {
        name: 'aggressr',
        title: 'Aggressr',
        author: 'Tyrann',
        played: 'occasionally',
        size: 'medium',
        mod: 'dm'
    },
    {
        name: 'shifter_nq',
        title: 'Shifter',
        author: 'foogs',
        played: 'occasionally',
        size: 'medium',
        mod: 'dm'
    },
    {
        name: 'catalyst',
        title: 'Catalyst',
        author: 'tehace',
        played: 'occasionally',
        size: 'medium',
        mod: 'dm'
    }
]
